import { render, staticRenderFns } from "./EachCountryKeyStatistics.vue?vue&type=template&id=4887441d&scoped=true&"
import script from "./EachCountryKeyStatistics.vue?vue&type=script&lang=js&"
export * from "./EachCountryKeyStatistics.vue?vue&type=script&lang=js&"
import style0 from "./EachCountryKeyStatistics.vue?vue&type=style&index=0&id=4887441d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4887441d",
  null
  
)

export default component.exports